import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import AnimateOnScroll from './AnimateOnScroll';

const About = () => {
  const { t } = useLanguage();

  const features = [
    { title: { fr: 'Durable', en: 'Sustainable' } },
    { title: { fr: 'Intelligente', en: 'Smart' } },
    { title: { fr: 'Sur mesure', en: 'Custom' } },
    { title: { fr: 'Garantie', en: 'Guaranteed' } },
  ];

  return (
    <section id="about" className="bg-neutral-50 py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="grid lg:grid-cols-2 gap-16 items-start mb-24">
          <AnimateOnScroll animation="fade-up">
            <p className="text-neutral-500 text-sm tracking-[0.3em] uppercase mb-4">
              {t({ fr: 'Notre Bureau', en: 'Our Office' })}
            </p>
            <h2 className="text-5xl md:text-7xl font-light text-neutral-900 leading-[1.1]">
              {t({ fr: 'Excellence', en: 'Excellence' })}
              <br />
              <span className="text-neutral-400">&amp;</span> {t({ fr: 'Innovation', en: 'Innovation' })}
            </h2>
          </AnimateOnScroll>
          
          <AnimateOnScroll animation="fade-up" delay={1}>
            <div className="lg:pt-16">
              <p className="text-neutral-500 text-lg leading-relaxed mb-8">
                {t({ 
                  fr: 'my iHome est une entreprise totale et générale qui concrétise vos projets de construction, de surélévation, transformation ou de rénovation énergétique de la conception à la livraison clé en main.',
                  en: 'my iHome is a comprehensive construction company that brings your building, extension, transformation or energy renovation projects to life from design to turnkey delivery.'
                })}
              </p>
              <p className="text-neutral-500 text-lg leading-relaxed">
                {t({ 
                  fr: 'Elle développe et construit des bâtiments durables et intelligents selon un mode de construction optimisé afin de diminuer la production de déchets et réduire les émissions CO2.',
                  en: 'We develop and build sustainable and intelligent buildings using an optimized construction method to reduce waste production and CO2 emissions.'
                })}
              </p>
            </div>
          </AnimateOnScroll>
        </div>

        {/* Video Section */}
        <AnimateOnScroll animation="scale">
          <div className="relative aspect-[16/9] mb-24 overflow-hidden">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-cover"
            >
              <source src="https://customer-assets.emergentagent.com/job_pt-text-input-1/artifacts/n3cdsad7_Constructions.mp4" type="video/mp4" />
            </video>
          </div>
        </AnimateOnScroll>

        {/* Features - Static, not clickable */}
        <div className="grid md:grid-cols-4 gap-px bg-neutral-200">
          {features.map((feature) => (
            <div key={feature.title.fr} className="bg-neutral-50 p-8 text-center">
              <p className="text-xl font-light text-neutral-700">
                {t(feature.title)}
              </p>
            </div>
          ))}
        </div>

        {/* Satisfaction Stats */}
        <div className="mt-24 grid md:grid-cols-2 gap-8">
          <AnimateOnScroll animation="fade-right">
            <div className="border border-neutral-200 p-12 bg-white">
              <p className="text-6xl font-light text-neutral-500 mb-4">100%</p>
              <p className="text-neutral-500 text-lg">
                {t({ 
                  fr: 'de nos clients promoteurs nous ont commandé un nouvel ouvrage et nous sont fidèles',
                  en: 'of our developer clients have ordered new projects from us and remain loyal'
                })}
              </p>
            </div>
          </AnimateOnScroll>
          <AnimateOnScroll animation="fade-left" delay={1}>
            <div className="border border-neutral-200 p-12 bg-white">
              <p className="text-6xl font-light text-neutral-500 mb-4">100%</p>
              <p className="text-neutral-500 text-lg">
                {t({ 
                  fr: 'de nos partenaires nous ont recommandé à leurs contacts',
                  en: 'of our partners have recommended us to their contacts'
                })}
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>
  );
};

export default About;
